// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exdialog-dialog {
  /* Safari/WebKit uses a non-standard name */
  width: intrinsic;
  /* Firefox/Gecko */
  width: -moz-max-content;
  /* Chrome */
  width: -webkit-max-content;
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 45px, rgba(0, 0, 0, 0.22) 0px 10px 18px;
}
.exdialog-dialog #body {
  padding: 0px;
  box-sizing: border-box;
  overflow-y: auto;
  font-size: 16;
  color: rgba(0, 0, 0, 0.6);
  flex: auto;
  z-index: 900;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
